export default {"src":"/_next/static/media/close.5d36b076.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};